<template>
  <div class="c-empty-content">
    <img src="../../images/empty_data.png" alt="" v-if="type==1">
    <img src="../../images/empty_study.png" alt="" v-else-if="type==2">
    <img src="../../images/empty-data.png" alt="" v-else>
    <p>{{content}}</p>
  </div>
</template>

<script>
export default {
  name: 'Empty',
  props: {
    content: {
      type: String,
      default: '暂无数据~',
    },
    type: {
      default: 1,
    },
  },
};
</script>

<style lang="scss" scoped>
.c-empty-content {
  height: 60vh;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: 70px;
  img {
    width: 234px;
    height: 247px;
  }
  p {
    margin-top: 12px;
    font-size: 14px;
    color: rgba(17, 31, 44, 0.6);
  }
}
</style>
